/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Popconfirm,
  Row,
  Upload,
} from "antd";
import React, { useState } from "react";

const { Dragger } = Upload;
const { TextArea } = Input;
const EditItems = (props) => {
  const [itemName, setItemName] = useState(props.data?.itemTitle);
  const [itemDescription, setItemDescription] = useState(
    props.data?.itemDescription
  );
  const [isItemOk, setIsItemOk] = useState(false);

  const handleInput = (e) => {
    setItemName(e.target.value);
  };
  const handleDescriptionInput = (e) => {
    setItemDescription(e.target.value);
  };
  const onFinish = (values) => {
    console.log("Form submitted!", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const validateInput = (_, value) => {
    if (!value) {
      return Promise.reject("can't be blank");
    }
    return Promise.resolve();
  };

  const handleItemTitle = (id) => {
    props.onEditValue(props.cardKey, id, itemName, itemDescription);
    message.success(`data update successfully.`);
    props.filterEditList(id);
  };
  const handleCancel = (id) => {
    props.filterEditList(id);
  };
  const handleDelete = (id) => {
    props.deleteItemsByKey(id);
    props.filterEditList(id);
  };

  const PhotoProps = {
    name: "file",
    multiple: true,
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  return (
    <div>
      <Card>
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="vertical"
        >
          <Row justify="space-between">
            <Col span={18}>
              <Form.Item
                name={props.data?.itemTitle}
                rules={[{ validator: validateInput }]}
                label="Name"
                required
              >
                <Input
                  autoFocus
                  onChange={handleInput}
                  style={{ width: "30%" }}
                  defaultValue={props.data?.itemTitle}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Row justify="space-between">
                <Col>
                  <a
                    style={
                      isItemOk ? { color: "#008A00" } : { color: "#627887" }
                    }
                    onClick={() => setIsItemOk(!isItemOk)}
                  >
                    <i className="fa-sharp fa-solid fa-circle-check"></i> OK
                  </a>
                </Col>
                <Col>
                  <a style={{ color: "#627887" }}>
                    <i className="fa-solid fa-flag"></i> FOLLOW-UP
                  </a>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="Description">
                <TextArea
                  onChange={handleDescriptionInput}
                  defaultValue={props.data?.itemDescription}
                  style={{
                    height: 80,
                  }}
                  placeholder="Enter some details for this item..."
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item label="Add Photos">
            <Dragger {...PhotoProps}>
              <Row justify="center">
                <Col>
                  <p className="ant-upload-text">Drag Photos Here</p>
                </Col>
                <Col span={1}>or</Col>
                <Col>
                  <Button>Choose Photos to Add</Button>
                </Col>
              </Row>
            </Dragger>
          </Form.Item>

          <Row justify="space-between">
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginRight: "10px" }}
                onClick={() => handleItemTitle(props.data.key)}
              >
                Save
              </Button>
              <Button onClick={() => handleCancel(props.data.key)}>
                Cancel
              </Button>
            </Col>
            <Col span={2}>
              <Form.Item>
                <Popconfirm
                  title="Sure to delete?"
                  onConfirm={() => handleDelete(props.data.key)}
                >
                  <a style={{ color: "red" }}>Delete Area</a>
                </Popconfirm>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default EditItems;
